import { render, staticRenderFns } from "./EvaluatorCommitteeModal.vue?vue&type=template&id=1a0b71ab&scoped=true"
import script from "./EvaluatorCommitteeModal.vue?vue&type=script&lang=js"
export * from "./EvaluatorCommitteeModal.vue?vue&type=script&lang=js"
import style0 from "./EvaluatorCommitteeModal.vue?vue&type=style&index=0&id=1a0b71ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0b71ab",
  null
  
)

export default component.exports